<div id="fuse-shortcuts" #shortcuts class="primary-bg">

    <!-- mobile header -->
    <div class="{{shortcutClass}}" *ngIf="!mobileShortcutsPanelActive" fxLayout="row" fxLayoutAlign="start center"
        fxHide fxShow.lt-md>
        <div fxFlex fxLayout="row">
            <div class="logo mr-15">
                <!--<img class="logo-icon" src="assets/images/tebex/login0.png" alt="logo">-->
                <span class="logo-text secondary-text">QREADY</span>

            </div>
            <button mat-icon-button (click)="OnHomeClick()" *ngIf="showHomeButton">
                <mat-icon class="logo-icon">home</mat-icon>
            </button>

            <!-- selection dropdown menu -->
            <button mat-icon-button (click)="OnSelectionViewClick()">
                <mat-icon class="secondary-text">search</mat-icon>
            </button>


            <button mat-icon-button [routerLink]="['/agenda/']" *ngIf="permissionList.indexOf(221)!=-1">
                <mat-icon class="secondary-text">assignment</mat-icon>
            </button>


            <button mat-icon-button [matMenuTriggerFor]="companyMenu">
                <mat-icon class="secondary-text">business</mat-icon>
            </button>

            <mat-menu #companyMenu="matMenu" [overlapTrigger]="false">
                <a (click)="OnCompanyClick()" *ngIf="permissionList.indexOf(1)!=-1">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Empresas</span>
                    </button>
                </a>

                <a (click)="router.navigate(['/staff-count'])">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Plantillas</span>
                    </button>
                </a>

                <a *ngIf="permissionList.indexOf(45)!=-1" (click)="router.navigate(['/convenios'])">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Convenios</span>
                    </button>
                </a>

            </mat-menu>


            <!--<button mat-icon-button [matMenuTriggerFor]="doctorMenu"-->
            <button mat-icon-button [matMenuTriggerFor]="doctorMenu" class="navbar-toggle-button doct-icon"
                *ngIf="this.permissionList.indexOf(101)!=-1 || this.permissionList.indexOf(115)!=-1">
                <img src="../../../../../assets/images/icons/doctor_icon.png" alt="">
            </button>

            <mat-menu #doctorMenu="matMenu" [overlapTrigger]="false">
                <a [routerLink]="['/doctor-maganement']" *ngIf="permissionList.indexOf(101)!=-1">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Médicos</span>
                    </button>
                </a>

                <a [routerLink]="['/coordinadore-main/']" *ngIf="permissionList.indexOf(819)!=-1 || permissionList.indexOf(801)!=-1">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Coordinadores</span>
                    </button>
                </a>

                <a [routerLink]="['/doctor-maganement/doctor-empresa']">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Empresas de medicos</span>
                    </button>
                </a>

                <a [routerLink]="['/administratives']" *ngIf="permissionList.indexOf(1005)!=-1">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Gestores</span>
                    </button>
                </a>

                <a [routerLink]="['/due']" *ngIf="permissionList.indexOf(1005)!=-1">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Due</span>
                    </button>
                </a>
            </mat-menu>

            <button mat-icon-button (click)="OnReportsClick()"  *ngIf="permissionList.indexOf(805)!=-1">
                <mat-icon class="logo-icon secondary-text">bar_chart</mat-icon>
            </button>

            <!-- <button mat-icon-button [routerLink]="['/users/']"  *ngIf="permissionList.indexOf(809)!=-1">
                <mat-icon class="logo-icon">people</mat-icon>
            </button> -->

            <!-- <button mat-icon-button class="navbar-toggle-button conve-icon" [routerLink]="['/convenios/']">
                <img src="../../../../../assets/images/icons/handshake.png" alt=""> 
            </button> -->

            <button mat-icon-button [matMenuTriggerFor]="moreMenu" class="navbar-toggle-button">
                <!--<button mat-icon-button [matMenuTriggerFor]="moreMenu">-->
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <!-- <button mat-icon-button [routerLink]="['/debug-view']" *ngIf="permissionList.indexOf(842)!=-1"> --NEXT UAT RELEASE
                <mat-icon class="secondary-text">local_library</mat-icon>
            </button> -->
            <!--<button class="mob-more"  mat-icon-button (click)="toggleBar()">
                <mat-icon class="secondary-text">more_vert</mat-icon>
            </button>-->



            <mat-menu #moreMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item [matMenuTriggerFor]="importsgMenu">
                    <mat-icon>account_circle</mat-icon>
                    <span>Gestión</span>
                </button>

                <mat-menu #importsgMenu="matMenu" class="sub-menu">
                    <a *ngIf="this.permissionList.indexOf(832)!=-1">
                        <button mat-menu-item [routerLink]="['/leave-import/']">Importar bajas
                        </button>
                    </a>
                    <a *ngIf="this.permissionList.indexOf(832)!=-1">
                        <button mat-menu-item [routerLink]="['/attribute-import/']">Importar atributos</button>
                    </a>
                    <a>
                        <button mat-menu-item [routerLink]="['/debug-view']"
                            *ngIf="permissionList.indexOf(842)!=-1">Depuración</button>
                    </a>
                    <a>
                        <button mat-menu-item [routerLink]="['/labor-calendar']"
                            *ngIf="permissionList.indexOf(895)!=-1">Calendarios</button>
                    </a>
                    <a>
                        <button mat-menu-item (click)="OpenDerivarAMutuaPopup()">Derivar a mutua</button>
                    </a>
                </mat-menu>


                <button mat-menu-item [matMenuTriggerFor]="sendingMenu">
                    <mat-icon>account_circle</mat-icon>
                    <span>Envíos</span>
                </button>
                <mat-menu #sendingMenu="matMenu" class="sub-menu">

                    <a>
                        <button mat-menu-item (click)="openTaskPopup()"
                            *ngIf="this.permissionList.indexOf(847)!=-1">Tareas</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openTaskEliminationPopup()"
                            *ngIf="this.permissionList.indexOf(847)!=-1">Notificación de eliminación de tareas</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openDischargesPopupPopup()"
                            *ngIf="this.permissionList.indexOf(848)!=-1">Altas</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openReportsPopup()"
                            *ngIf="this.permissionList.indexOf(850)!=-1">Listados</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openDischargeRequestPopup()"
                            *ngIf="this.permissionList.indexOf(848)!=-1">Solicitudes de alta</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openAddressRequestPopup()"
                            *ngIf="this.permissionList.indexOf(852)!=-1">Solicitudes de dirección</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openStaffRequestPopup()"
                            *ngIf="this.permissionList.indexOf(853)!=-1">Solicitudes de plantillas</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="sendCitationPopup()" *ngIf="this.permissionList.indexOf(818)!=-1"
                            class="hidden">Citaciones formales</button>
                    </a>

                    <a>
                        <button mat-menu-item [routerLink]="['/send-sms/']" *ngIf="permissionList.indexOf(1003)!=-1">SMS
                        </button>
                    </a>

                </mat-menu>

                <button mat-menu-item [matMenuTriggerFor]="bills" *ngIf="permissionList.indexOf(701)!=-1">
                    <mat-icon>account_circle</mat-icon>
                    <span>Minutas</span>
                </button>

                <!-- <a [routerLink]="['/attribute-import/']">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Importación de atributos</span>
                    </button>
                </a> -->

                <!-- <a [routerLink]="['/coordinators/']">-->


                <button mat-menu-item [matMenuTriggerFor]="subMenu">
                    <mat-icon>account_circle</mat-icon>
                    <span>Mantenimientos</span>
                </button>



                <button mat-menu-item [matMenuTriggerFor]="lopd"
                    *ngIf="permissionList.indexOf(841)!=-1 || permissionList.indexOf(601)!=-1">
                    <mat-icon>account_circle</mat-icon>
                    <span>LOPD</span>
                </button>
                <mat-menu #lopd="matMenu" class="sub-menu">

                    <a>
                        <button mat-menu-item *ngIf="permissionList.indexOf(601)!=-1" (click)="DatacancelPopup()">Anular
                            cancelación de datos</button>
                    </a>

                    <a *ngIf="permissionList.indexOf(841)!=-1">
                        <button mat-menu-item [routerLink]="['/delete-leaves/']">Registro de eliminados</button>
                    </a>
                </mat-menu>

                <button mat-menu-item [routerLink]="['/users/']" *ngIf="permissionList.indexOf(809)!=-1">
                    <mat-icon>account_circle</mat-icon>
                    <span>Usuarios</span>
                </button>

            </mat-menu>

            <mat-menu #subMenu="matMenu" class="sub-menu">
                <a [routerLink]="['/plantillas_lopd/']" *ngIf="permissionList.indexOf(4)!=-1">
                    <button mat-menu-item>Plantillas LOPD</button>
                </a>

                <a [routerLink]="['/plantillas_citacion/']" *ngIf="permissionList.indexOf(4)!=-1">
                    <button mat-menu-item>Plantillas Citación</button>
                </a>
            </mat-menu>

            <mat-menu #bills="matMenu" class="sub-menu">
                <a [routerLink]="['/monthly-doctor-expenses-view/']" *ngIf="permissionList.indexOf(702)!=-1">
                    <button mat-menu-item>Gastos Médicos</button>
                </a>
                <a>
                    <button mat-menu-item (click)="confirmTransferActuaciones()">Actuaciones</button>
                </a>
                <a>
                    <button mat-menu-item (click)="confirmTransferOtrosGastos()">Otros Gastos</button>
                </a>
                <a>
                    <button mat-menu-item (click)="confirmImprimirDeuda()">Imprimir minutas</button>
                </a>
                <a>
                    <button mat-menu-item (click)="confirmCreateBill()">Crear facturas de médicos</button>
                </a>
                <a [routerLink]="['monthly-doctor-expenses-view/doctor-bill-view/']">
                    <button mat-menu-item>Mostrar facturas de medicos</button>
                </a>
                <a>
                    <button mat-menu-item (click)="confirmClosingBillingPeriod()">Cerrar facturación</button>
                </a>
            </mat-menu>
        </div>
        <div fxFlex fxLayout="row">

            <!-- Search -->
            <div class="search-wrapper" fxFlex fxLayout="row" fxLayoutAlign="start center">
                <div class="search" fxLayout="row" fxLayoutAlign="start center">
                    <mat-form-field>
                        <input matInput aria-label="Number" #textbox [(ngModel)]="headerService.textsearch"
                            (ngModelChange)="modelChanged($event)" (keydown.enter)="searchEmployee(textbox.value)"
                            [matAutocomplete]="auto" fxFlex>
                        <mat-autocomplete #auto="matAutocomplete" id="mainSearch" [panelWidth]="750">
                            <mat-option class="mat-opt" *ngFor="let option of options" [value]=""
                                (click)="selectedOption($event.target.textsearch, option)"
                                [ngStyle]="{'border-bottom': '1px solid rgba(0,0,0,0.40)'}">
                                {{option.indice }}  <span class="m-r-10 m-l-10">-</span> {{ option.nombre }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon class="icon" [class.disabled]="isSearchEnable"
                            (click)="searchEmployee(textbox.value)">search</mat-icon>
                    </mat-form-field>
                </div>
            </div>

            <!-- Add new employee Popup 'Plus' icon-->

            <button mat-icon-button *ngIf="this.permissionList.indexOf(601)!=-1" (click)="showAddNewEmployeePopup()"
                class="navbar-toggle-button">
                <mat-icon class="secondary-text">add</mat-icon>
            </button>
            <!-- end -->



            <div fxLayout="row" fxLayoutAlign="start center">

                <!-- Empresa select -->
                <div class="menuSelectOption" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <span class="title-span secondary-text">Empresa</span>
                    <app-tree-view [origin]="0"></app-tree-view>
                    <!-- ORIGIN IS 0 FOR THE TREE VIEW THAT IS IN THE HEADER -->
                </div>

            </div>

        </div>
    </div>
    <!-- mobile header end -->

    <div class="shortcuts" fxLayout="row" fxHide fxShow.gt-sm>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex="0 1 auto">

            <div class="logo mr-15">
                <!--<img (click)="OnHomeClick()" class="logo-icon" src="assets/images/tebex/login0.png" alt="logo">-->
                <span (click)="OnHomeClick()" class="logo-text secondary-text">QREADY</span>
            </div>

            <button mat-icon-button (click)="OnHomeClick()" *ngIf="showHomeButton">
                <mat-icon class="logo-icon">home</mat-icon>
            </button>

            <!-- selection dropdown menu -->
            <button mat-icon-button (click)="OnSelectionViewClick()">
                <mat-icon class="secondary-text">search</mat-icon>
            </button>


            <button mat-icon-button [routerLink]="['/agenda/']" *ngIf="permissionList.indexOf(221)!=-1">
                <mat-icon class="secondary-text">assignment</mat-icon>
            </button>


            <button mat-icon-button [matMenuTriggerFor]="companyMenu">
                <mat-icon class="secondary-text">business</mat-icon>
            </button>

            <mat-menu #companyMenu="matMenu" [overlapTrigger]="false">
                <a (click)="OnCompanyClick()" *ngIf="permissionList.indexOf(1)!=-1">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Empresas</span>
                    </button>
                </a>

                <a (click)="router.navigate(['/staff-count'])">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Plantillas</span>
                    </button>
                </a>

                <a *ngIf="permissionList.indexOf(45)!=-1" (click)="router.navigate(['/convenios'])">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Convenios</span>
                    </button>
                </a>

            </mat-menu>


            <!--<button mat-icon-button [matMenuTriggerFor]="doctorMenu"-->
            <button mat-icon-button [matMenuTriggerFor]="doctorMenu" class="navbar-toggle-button doct-icon"
                *ngIf="this.permissionList.indexOf(101)!=-1 || this.permissionList.indexOf(115)!=-1">
                <img src="../../../../../assets/images/icons/doctor_icon.png" alt="">
            </button>

            <mat-menu #doctorMenu="matMenu" [overlapTrigger]="false">
                <a [routerLink]="['/doctor-maganement']" *ngIf="permissionList.indexOf(101)!=-1">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Médicos</span>
                    </button>
                </a>

                <a [routerLink]="['/coordinadore-main/']" *ngIf="permissionList.indexOf(819)!=-1 || permissionList.indexOf(801)!=-1">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Coordinadores</span>
                    </button>
                </a>

                <a [routerLink]="['/doctor-maganement/doctor-empresa']">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Empresas de medicos</span>
                    </button>
                </a>

                <a [routerLink]="['/administratives']" *ngIf="permissionList.indexOf(1005)!=-1">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Gestores</span>
                    </button>
                </a>

                <a [routerLink]="['/due']" *ngIf="permissionList.indexOf(1005)!=-1">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Due</span>
                    </button>
                </a>
            </mat-menu>

            <button mat-icon-button (click)="OnReportsClick()" *ngIf="permissionList.indexOf(805)!=-1">
                <mat-icon class="logo-icon secondary-text">bar_chart</mat-icon>
            </button>

            <!-- <button mat-icon-button [routerLink]="['/users/']"  *ngIf="permissionList.indexOf(809)!=-1">
                <mat-icon class="logo-icon">people</mat-icon>
            </button> -->

            <!-- <button mat-icon-button class="navbar-toggle-button conve-icon" [routerLink]="['/convenios/']">
                <img src="../../../../../assets/images/icons/handshake.png" alt=""> 
            </button> -->

            <button mat-icon-button [matMenuTriggerFor]="moreMenu" class="navbar-toggle-button">
                <!--<button mat-icon-button [matMenuTriggerFor]="moreMenu">-->
                <mat-icon class="secondary-text">menu</mat-icon>
            </button>

            <!-- <button mat-icon-button [routerLink]="['/debug-view']" *ngIf="permissionList.indexOf(842)!=-1"> --NEXT UAT RELEASE
                <mat-icon class="secondary-text">local_library</mat-icon>
            </button> -->
            <!--<button class="mob-more"  mat-icon-button (click)="toggleBar()">
                <mat-icon class="secondary-text">more_vert</mat-icon>
            </button>-->



            <mat-menu #moreMenu="matMenu" [overlapTrigger]="false">

                <button mat-menu-item [matMenuTriggerFor]="importsgMenu">
                    <mat-icon>account_circle</mat-icon>
                    <span>Gestión</span>
                </button>

                <mat-menu #importsgMenu="matMenu" class="sub-menu">
                    <a *ngIf="this.permissionList.indexOf(832)!=-1">
                        <button mat-menu-item [routerLink]="['/leave-import/']">Importar bajas
                        </button>
                    </a>
                    <a *ngIf="this.permissionList.indexOf(832)!=-1">
                        <button mat-menu-item [routerLink]="['/attribute-import/']">Importar atributos</button>
                    </a>
                    <a>
                        <button mat-menu-item [routerLink]="['/debug-view']"
                            *ngIf="permissionList.indexOf(842)!=-1">Depuración</button>
                    </a>
                    <a>
                        <button mat-menu-item [routerLink]="['/labor-calendar']"
                            *ngIf="permissionList.indexOf(895)!=-1">Calendarios</button>
                    </a>
                    <a>
                        <button mat-menu-item (click)="OpenDerivarAMutuaPopup()">Derivar a mutua</button>
                    </a>
                </mat-menu>


                <button mat-menu-item [matMenuTriggerFor]="sendingMenu">
                    <mat-icon>account_circle</mat-icon>
                    <span>Envíos</span>
                </button>
                <mat-menu #sendingMenu="matMenu" class="sub-menu">

                    <a>
                        <button mat-menu-item (click)="openTaskPopup()"
                            *ngIf="this.permissionList.indexOf(847)!=-1">Tareas</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openTaskEliminationPopup()"
                            *ngIf="this.permissionList.indexOf(847)!=-1">Notificación de eliminación de tareas</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openDischargesPopupPopup()"
                            *ngIf="this.permissionList.indexOf(848)!=-1">Altas</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openReportsPopup()"
                            *ngIf="this.permissionList.indexOf(850)!=-1">Listados</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openDischargeRequestPopup()"
                            *ngIf="this.permissionList.indexOf(848)!=-1">Solicitudes de alta</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openAddressRequestPopup()"
                            *ngIf="this.permissionList.indexOf(852)!=-1">Solicitudes de dirección</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="openStaffRequestPopup()"
                            *ngIf="this.permissionList.indexOf(853)!=-1">Solicitudes de plantillas</button>
                    </a>

                    <a>
                        <button mat-menu-item (click)="sendCitationPopup()" *ngIf="this.permissionList.indexOf(818)!=-1"
                            class="hidden">Citaciones formales</button>
                    </a>

                    <a>
                        <button mat-menu-item [routerLink]="['/send-sms/']" *ngIf="permissionList.indexOf(1003)!=-1">SMS
                        </button>
                    </a>
                </mat-menu>

                <button mat-menu-item [matMenuTriggerFor]="bills" *ngIf="permissionList.indexOf(701)!=-1">
                    <mat-icon>account_circle</mat-icon>
                    <span>Minutas</span>
                </button>

                <!-- <a [routerLink]="['/attribute-import/']">
                    <button mat-menu-item>
                        <mat-icon>account_circle</mat-icon>
                        <span>Importación de atributos</span>
                    </button>
                </a> -->

                <!-- <a [routerLink]="['/coordinators/']">-->


                <button mat-menu-item [matMenuTriggerFor]="subMenu">
                    <mat-icon>account_circle</mat-icon>
                    <span>Mantenimientos</span>
                </button>



                <button mat-menu-item [matMenuTriggerFor]="lopd"
                    *ngIf="permissionList.indexOf(841)!=-1 || permissionList.indexOf(601)!=-1">
                    <mat-icon>account_circle</mat-icon>
                    <span>LOPD</span>
                </button>
                <mat-menu #lopd="matMenu" class="sub-menu">

                    <a>
                        <button mat-menu-item *ngIf="permissionList.indexOf(601)!=-1" (click)="DatacancelPopup()">Anular
                            cancelación de datos</button>
                    </a>

                    <a *ngIf="permissionList.indexOf(841)!=-1">
                        <button mat-menu-item [routerLink]="['/delete-leaves/']">Registro de eliminados</button>
                    </a>
                </mat-menu>

                <button mat-menu-item [routerLink]="['/users/']" *ngIf="permissionList.indexOf(809)!=-1">
                    <mat-icon>account_circle</mat-icon>
                    <span>Usuarios</span>
                </button>
                
                <button mat-menu-item [routerLink]="['/cartera-empresas/']" *ngIf="permissionList.indexOf(809)!=-1">
                    <mat-icon>account_circle</mat-icon>
                    <span>Grupos de empresa</span>
                </button>

            </mat-menu>

            <mat-menu #subMenu="matMenu" class="sub-menu">
                <a [routerLink]="['/plantillas_lopd/']" *ngIf="permissionList.indexOf(4)!=-1">
                    <button mat-menu-item>Plantillas LOPD</button>
                </a>

                <a [routerLink]="['/plantillas_citacion/']" *ngIf="permissionList.indexOf(4)!=-1">
                    <button mat-menu-item>Plantillas Citación</button>
                </a>
            </mat-menu>

            <mat-menu #bills="matMenu" class="sub-menu">
                <a [routerLink]="['/monthly-doctor-expenses-view/']" *ngIf="permissionList.indexOf(702)!=-1">
                    <button mat-menu-item>Gastos Médicos</button>
                </a>
                <a>
                    <button mat-menu-item (click)="confirmTransferActuaciones()">Actuaciones</button>
                </a>
                <a>
                    <button mat-menu-item (click)="confirmTransferOtrosGastos()">Otros Gastos</button>
                </a>
                <a>
                    <button mat-menu-item (click)="confirmImprimirDeuda()">Imprimir minutas</button>
                </a>
                <a>
                    <button mat-menu-item (click)="confirmCreateBill()">Crear facturas de médicos</button>
                </a>
                <a [routerLink]="['monthly-doctor-expenses-view/doctor-bill-view/']">
                    <button mat-menu-item>Mostrar facturas de medicos</button>
                </a>
                <a>
                    <button mat-menu-item (click)="confirmClosingBillingPeriod()">Cerrar facturación</button>
                </a>
            </mat-menu>
            <!-- Hide temp -->
            <!-- Search -->
            <div class="search-wrapper" fxFlex fxLayout="row" fxLayoutAlign="start center">
                <div class="search" fxLayout="row" fxLayoutAlign="start center">
                    <mat-form-field>
                        <input matInput aria-label="Number" #textbox [(ngModel)]="headerService.textsearch"
                            (ngModelChange)="modelChanged($event)" (keydown.enter)="searchEmployee(textbox.value)"
                            [matAutocomplete]="auto" fxFlex> 
                        <mat-autocomplete #auto="matAutocomplete" id="mainSearch" [panelWidth]="1000" class = "searchPanelMain">
                            <mat-option class="mat-opt" *ngFor="let option of options" [value]=""
                                (click)="selectedOption($event.target.textsearch, option)"
                                [ngStyle]="{'border-bottom': '1px solid rgba(0,0,0,0.40)'}">
                                {{option.indice }} <span class="m-r-10 m-l-10">-</span> {{ option.nombre }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon class="icon" [class.disabled]="!isSearchEnable"
                            (click)="searchEmployee(textbox.value)">search</mat-icon>
                    </mat-form-field>
                </div>
            </div>

            <!-- Add new employee Popup 'Plus' icon-->

            <button mat-icon-button *ngIf="this.permissionList.indexOf(601)!=-1" (click)="showAddNewEmployeePopup()"
                class="navbar-toggle-button">
                <mat-icon class="secondary-text">add</mat-icon>
            </button>
            <!-- end -->



            <div fxLayout="row" fxLayoutAlign="start center">

                <!-- Empresa select -->
                <div class="menuSelectOption" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <span class="title-span secondary-text">Empresa</span>
                    <app-tree-view [origin]="0"></app-tree-view>
                    <!-- ORIGIN IS 0 FOR THE TREE VIEW THAT IS IN THE HEADER -->
                </div>

            </div>

            <div class="shortcuts-mobile-close" fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.lt-md>
                <button mat-icon-button (click)="hideMobileShortcutsPanel()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

        </div>

    </div>

</div>